/**Numerical are valid*/
export const isDateKey = (keyCode: number) =>
  (keyCode >= 48 && keyCode <= 57) || (keyCode >= 96 && keyCode <= 105);

/**backspace/delete/tab is valid
  left- rightkey is valid*/
export const isUtilityKey = (keyCode: number) =>
  keyCode === 8 || // backspace
  keyCode === 46 || // delete
  keyCode === 9 || // tab
  keyCode === 37 || // left
  keyCode === 39 || // right
  keyCode === 35 || // end
  keyCode === 36; // home

export const isFunctionKey = (keyCode: number, ctrlKey: boolean) =>
  (keyCode === 67 && ctrlKey) || // ctrl+c
  (keyCode === 86 && ctrlKey) || // ctrl+v
  (keyCode === 88 && ctrlKey) || // ctrl+x
  (keyCode === 65 && ctrlKey); // ctrl+a

/**Dot, hyphen and forward slash is valid */
export const isSeperatorKey = (keyCode: number, shift: boolean) =>
  keyCode === 189 ||
  keyCode === 109 ||
  keyCode === 190 ||
  (keyCode === 55 && shift);
